var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-2"},[(_vm.status == 'pending')?_c('i',{staticClass:"bi bi-hourglass text-warning"}):_vm._e(),(_vm.status == 'cancel')?_c('i',{staticClass:"bi bi-sign-do-not-enter text-danger"}):_vm._e(),(_vm.status == 'complete')?_c('i',{staticClass:"bi bi-check-circle text-success"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }